import request from '../../components/api/api';
import {ROOT_URL} from '../../config';
import {fetchedAgeGroups} from './actions';

export function fetchAgeGroups() {
    return (dispatch) => {
        let options = {
            url: `${ROOT_URL}/age-groups`,
            method: 'GET'
        };
        return request(options, dispatch)
            .then(response => dispatch(fetchedAgeGroups(response.data)));
    };
}


// WEBPACK FOOTER //
// ./src/containers/reviews/thunks.js